export const INTERRUPT_ROUTE_3DS_STEP_UP = '/3ds-step-up';
export const INTERRUPT_ROUTE_3DS_CALLBACK = '/3ds-callback';
